import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

/**
 * Confirmation dialog for granting/revoking admin on a user (C2D-991). Revoking admin
 * (demote) previously fired on a single click of a small tooltip-only icon, so it was
 * both easy to miss and easy to trigger by accident; this makes the action deliberate.
 */
const RoleChangeModal = (props) => {
  const [fetchingData, setFetchingData] = useState(false);
  const pending = props.userPendingRoleChange || {};
  const makeAdmin = pending.admin === true;
  const email = pending.user && pending.user.email;

  return (
    <Modal onHide={() => props.handleClose()} show={props.show}>
      <Modal.Header closeButton>
        {makeAdmin ? 'Grant admin privileges' : 'Revoke admin privileges'}
      </Modal.Header>
      <Modal.Body>
        {makeAdmin
          ? <>Give <strong>{email}</strong> administrator access? They will be able to manage users, data sources, and platform settings.</>
          : <>Remove administrator access from <strong>{email}</strong>? They will keep their account but lose admin-only capabilities.</>}
      </Modal.Body>
      <Modal.Footer className='d-flex flex-nowrap'>
        <div className='w-50'>
          <Button
            className='mr-2 pr-3 pl-3 w-100'
            variant='outline-secondary'
            onClick={() => props.handleClose()}
          >
            CANCEL
          </Button>
        </div>
        <div className='w-50'>
          <Button
            disabled={fetchingData}
            className='pr-3 pl-3 w-100'
            variant={makeAdmin ? 'primary' : 'danger'}
            type='button'
            data-testid='role-change-confirm'
            onClick={async () => {
              setFetchingData(true);
              await props.handleConfirm(pending.user, { admin: makeAdmin });
              setFetchingData(false);
              props.handleClose();
            }}
          >
            {fetchingData && (
              <Spinner className='mr-2' as='span' animation='border' size='sm' role='status' aria-hidden='true' />
            )}
            {makeAdmin ? 'GRANT ADMIN' : 'REVOKE ADMIN'}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RoleChangeModal;
